export const why_constants = [
  {
    title: "Why Choose Small Language Models",
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1755251232/powerdbyai/slm-1_xw6lwq.png",
    features: [
      "Lower computational requirements and costs",
      "Faster inference times for real-time applications",
      "Enhanced privacy with on-premises deployment options",
      "Reduced latency for better user experience",
      "Customizable for specific industry vocabularies",
    ],
    cta: "See Cost Savings",
    ctaLink: "/signup",
  },
  {
    title: "SLM Applications",
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1755251233/powerdbyai/slm-2_v80prd.png",
    features: [
      "Customer service chatbots and virtual assistants",
      "Document processing and information extraction",
      "Local language support for African languages",
      "Educational technology and e-learning platform",
      "Healthcare documentation and analysis",
    ],
    cta: "Find Your Use Case",
    ctaLink: "/signup",
  },
];
